import {useDispatch, useSelector} from "react-redux";
import AccountingTypeList from "./AccountingTypeList";
import {useEffect} from "react";
import {HeaderActions, PageHeader, ReportActions} from "components/Reports/components";
import {apiGetAccountingTypes} from "api/accountingTypeApi";
import {Container} from "@mui/material";

const tab = {
    title: "جدول حساب ها",
    description: "نرم افزار حسابداری",
};

const AccountingTypeComponent = () => {
    const dispatch = useDispatch();
    const {token} = useSelector((state: any) => state).businessReducer.business;
    const {accountingTypesList} = useSelector((state: any) => state).accountingReducer as {
        accountingTypesList: accountTypeType;
    };

    const refetchFunction = (t: any) => {
        // @ts-ignore
        return dispatch(apiGetAccountingTypes(t || token));
    };

    useEffect(() => {
        refetchFunction(token);
    }, []);

    return (
        <Container maxWidth="lg">
            <div className="warp-table">
                <div className="header-table">
                    <PageHeader tab={tab}/>
                    <HeaderActions/>
                </div>
                <ReportActions/>

                {accountingTypesList && (
                    // @ts-ignore
                    <AccountingTypeList refetchFunction={refetchFunction} data={accountingTypesList}/>
                )}
            </div>
        </Container>
    );
};

export default AccountingTypeComponent;
